// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FoursquareOutlinedSvg from "@fishx/icons-svg/es/asn/FoursquareOutlined";
import FishxIcon from '../components/FishxIcon';

var FoursquareOutlined = function FoursquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FoursquareOutlinedSvg
  }));
};

FoursquareOutlined.displayName = 'FoursquareOutlined';
export default React.forwardRef(FoursquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FoursquareOutlined.js
// module id = 2834
// module chunks = 0